import type { TestimonialSection } from "@/types/content";

interface Props {
  section: TestimonialSection;
}

export default function TestimonialSectionBlock({ section }: Props) {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-5xl mx-auto">
        {section.title && (
          <h2 className="text-2xl md:text-3xl font-bold text-slate-800 text-center mb-10">
            {section.title}
          </h2>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {section.testimonials.map((t) => (
            <div
              key={t._key}
              className="bg-white rounded-xl p-6 border border-slate-100"
            >
              <div className="w-8 h-8 flex items-center justify-center text-primary mb-4">
                <i className="ri-double-quotes-l text-2xl" />
              </div>
              <p className="text-sm text-slate-600 leading-relaxed mb-4 italic">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3">
                {t.avatar && (
                  <img
                    loading="lazy"
                    src={t.avatar}
                    alt={t.author}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                )}
                <div>
                  <p className="text-sm font-medium text-slate-800">
                    {t.author}
                  </p>
                  {t.role && (
                    <p className="text-xs text-slate-400">{t.role}</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}